export default __webpack_public_path__ + "static/media/vanti.a769df09.png";